module.exports = __webpack_public_path__ + "img/44.92cfa216.png";